import "react-app-polyfill/ie11"; // For IE 11 support
import "custom-event-polyfill";
import React from "react";
import App from "./App";
import { unregister } from "./registerServiceWorker";
import { createRoot } from "react-dom/client";
import { msalInstance, privateAPI, publicAPI, attachApimAopHttpLogging } from "tds_shared_ui";
import { MsalProvider } from "@azure/msal-react";
import { installApimAuth } from "./setupApimAuth";

installApimAuth();
attachApimAopHttpLogging(privateAPI);
attachApimAopHttpLogging(publicAPI);

const rootElement = document.getElementById("root");
if (!rootElement) {
    throw new Error("Failed to find the root element");
}

const root = createRoot(rootElement);
root.render(
    <MsalProvider instance={msalInstance}>
        <App />
    </MsalProvider>
);
unregister();
